/**
 * Random per-browser id (persisted in localStorage).
 * Purely random, feeds server-side anti-abuse clustering. localStorage is
 * synchronous on web, so unlike mobile this never misses the first requests.
 */
const KEY = 'dabba-device-id';

let cached: string | null = null;

export function getDeviceId(): string | null {
  if (cached) return cached;
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
      localStorage.setItem(KEY, id);
    }
    cached = id;
  } catch {
    // storage unavailable (private mode) — header simply omitted
  }
  return cached;
}
